import { BaseResource } from "../base-resource";

export class UserDefinedFieldData extends BaseResource {
  value : string;
  file : string;
  customFieldHeaderID : number;
  referenceEntityId : string;
  entityTypeID : number;
}
